<template>

  <div>
    <!--
    <div class="page-btn" v-if="items.length > 0">
      <span style="line-height: 36px">Viewing {{getCurrentStartItem}} to {{getCurrentEndItem}} of {{items.length}} Items</span>
      <md-button @click="handleGoFirstPage"><<</md-button>
      <md-button @click="handleGoLeftPage"><</md-button>
      <md-button v-if="isPageInRange(p)" :class="getBtnClass(p)" :key="p" v-for="p in getTotalPages" @click="handleChangePage(p)">{{p}}</md-button>
      <md-button @click="handleGoRightPage">></md-button>
      <md-button @click="handleGoLastPage">>></md-button>
    </div>
  -->
    <slot :pageItems="pageItems"/>
  </div>

</template>

<style scoped lang="scss">
  .page-btn {
    text-align: right;

    button {
      margin: 0;
      padding: 0;
    }
    .md-button {
      min-width: 32px;
    }
  }
</style>

<script>
  const maxPagingItems = 7;

  export default {
    props: {
      items: Array,
      itemsPerPage:{
        default: 16,
        type: Number
      }
    },
    data: () => ({
      pageItems: [],
      currentPage: 1,
    }),
    computed: {
      getTotalPages() {
        let divide = parseInt(`${Math.floor(this.items.length / this.itemsPerPage)}`, 0);
        let more = this.items.length % this.itemsPerPage > 0 ? 1 : 0;
        return _.range(1, divide + 1 + more);
      },
      getCurrentStartItem() {
        return (this.currentPage - 1) * this.itemsPerPage + 1
      },
      getCurrentEndItem() {
        const res = this.currentPage * this.itemsPerPage;
        if (res > this.items.length) {
          return this.items.length;
        }
        return res;
      },
    },
    watch: {
      items() {
        // if (this.currentPage !== 1) {
        //   this.currentPage = 1;
        // } else {
        //   this.refreshPage();
        // }
        console.log(`currentpage: ${this.currentPage} totalpage: ${this.getLastPage}`);
        //if (this.currentPage != 1) {
        if (this.getLastPage < this.currentPage) {
           this.currentPage = 1;
        }
        this.refreshPage();
      },
      currentPage() {
        this.refreshPage();
      },
    },
    mounted() {
      
      this.refreshPage();
    },
    methods: {
      isPageInRange(p) {
        const range = parseInt(`${maxPagingItems / 2}`, 0);
        if (p < this.currentPage - range) {
          return (p + maxPagingItems) > this.getTotalPages.length;
        }
        if (p > this.currentPage + range) {
          return (p - maxPagingItems) <= 0;
        }

        return true;
      },
      getBtnClass(p) {
        const classes = {};
        if (this.currentPage === p) {
          classes['md-primary'] = true;
        }
        return classes;
      },
      refreshPage() {
        const rest = (this.currentPage - 1) * this.itemsPerPage;
        if (this.items && this.items.length > 0) {
          this.pageItems = _(this.items).chain()
            .rest(rest)
            .take(this.itemsPerPage)
            .value();
        } else {
          this.pageItems = [];
        }
      },
      handleChangePage(p) {
        this.currentPage = p;
      },
      handleGoFirstPage() {
        this.currentPage = 1;
      },
      handleGoLeftPage() {
        if (this.currentPage !== 1) {
          this.currentPage = this.currentPage - 1;
        }
      },
      handleGoRightPage() {
        if (this.currentPage < this.getTotalPages.length) {
          this.currentPage = this.currentPage + 1;
        }
      },
      handleGoLastPage() {
        this.currentPage = this.getTotalPages.length;
      },
    },


  }
</script>